export default "__VITE_PUBLIC_ASSET__bc7466db__"